import { render, staticRenderFns } from "./PaymentsToku.vue?vue&type=template&id=2dddeccb&"
import script from "./PaymentsToku.vue?vue&type=script&lang=js&"
export * from "./PaymentsToku.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports